"use client";

import { c as _c } from "react/compiler-runtime";
import { CommonSelectItem } from "@/components/utils/select/CommonSelect";
import CommonDropdown from "@/components/utils/select/dropdown/CommonDropdown";
import { ApiWallet } from "@/generated/models/ApiWallet";
import { formatAddress } from "@/helpers/Helpers";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { RefObject, useEffect, useMemo, useState } from "react";
import UserAddressesSelectDropdownItem from "./UserAddressesSelectDropdownItem";
type SelectedType = string | null;
export default function UserAddressesSelectDropdown(t0) {
  const $ = _c(24);
  const {
    wallets,
    containerRef,
    onActiveAddress
  } = t0;
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      label: "All Addresses",
      value: null,
      key: "all",
      childrenProps: null
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== wallets) {
    t2 = [t1, ...wallets.map(_temp)];
    $[1] = wallets;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const items = t2;
  let t3;
  if ($[3] !== searchParams) {
    t3 = () => {
      const addressParam = searchParams?.get("address");
      return addressParam ? addressParam.toLowerCase() : null;
    };
    $[3] = searchParams;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getAddressFromQuery = t3;
  let t4;
  if ($[5] !== getAddressFromQuery) {
    t4 = getAddressFromQuery();
    $[5] = getAddressFromQuery;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const [activeAddress, setActiveAddress] = useState(t4);
  let t5;
  let t6;
  if ($[7] !== searchParams) {
    t5 = () => {
      const next = searchParams?.get("address");
      setActiveAddress(next ? next.toLowerCase() : null);
    };
    t6 = [searchParams];
    $[7] = searchParams;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[10] !== activeAddress || $[11] !== onActiveAddress) {
    t7 = () => {
      onActiveAddress(activeAddress);
    };
    t8 = [activeAddress, onActiveAddress];
    $[10] = activeAddress;
    $[11] = onActiveAddress;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  useEffect(t7, t8);
  let t9;
  if ($[14] !== activeAddress || $[15] !== pathname || $[16] !== router || $[17] !== searchParams) {
    t9 = address => {
      const params = new URLSearchParams(searchParams?.entries ? Array.from(searchParams.entries()) : []);
      if (!address || address === activeAddress) {
        setActiveAddress(null);
        params.delete("address");
        const newUrl = pathname + (params.toString() ? `?${params.toString()}` : "");
        router.push(newUrl, {
          scroll: false
        });
        return;
      }
      const lower = address.toLowerCase();
      setActiveAddress(lower);
      params.set("address", lower);
      const newUrl_0 = pathname + (params.toString() ? `?${params.toString()}` : "");
      router.push(newUrl_0, {
        scroll: false
      });
    };
    $[14] = activeAddress;
    $[15] = pathname;
    $[16] = router;
    $[17] = searchParams;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const onAddressChange = t9;
  const activeItem = items.find(item => item.value === activeAddress)?.value ?? null;
  let t10;
  if ($[19] !== activeItem || $[20] !== containerRef || $[21] !== items || $[22] !== onAddressChange) {
    t10 = <CommonDropdown items={items} filterLabel="Address" activeItem={activeItem} containerRef={containerRef} setSelected={onAddressChange} renderItemChildren={_temp2} />;
    $[19] = activeItem;
    $[20] = containerRef;
    $[21] = items;
    $[22] = onAddressChange;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}
function _temp2(item_0) {
  return item_0.childrenProps ? <UserAddressesSelectDropdownItem wallet={item_0.childrenProps} /> : <></>;
}
function _temp(wallet) {
  return {
    label: formatAddress(wallet.display ?? wallet.wallet),
    value: wallet.wallet.toLowerCase(),
    key: wallet.wallet.toLowerCase(),
    childrenProps: wallet
  };
}